import { render, staticRenderFns } from "./ToggleEnableMailings.vue?vue&type=template&id=59a0f6ea&scoped=true&"
import script from "./ToggleEnableMailings.vue?vue&type=script&lang=js&"
export * from "./ToggleEnableMailings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a0f6ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
